// サービス終了に伴いAPIを停止したため、更新系の操作は利用できない
import { rejectServiceClosed } from 'api/errors';

interface PatchUserPasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export const usePasswordChange = () => {
  const patchUserPassword = (_data: PatchUserPasswordRequest): Promise<void> => rejectServiceClosed();

  return { patchUserPassword };
};
